import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seccion-inmaterial',
  templateUrl: './seccion-inmaterial.component.html',
  styleUrls: ['./seccion-inmaterial.component.css']
})
export class SeccionInmaterialComponent implements OnInit {

  

  constructor() { }

  ngOnInit(): void {
  }

}
